import { useQuery } from "@tanstack/react-query";
import { getActivationsForBrand } from "apis/brand";
import { useRouter } from "components/hooks";
import { useDataProviderContext } from "pages/MagnetDetails/DataProvider";
import { useState } from "react";
import { toast } from "react-toastify";
import { workInProgressAlert } from "utils/HelperFunctions";
import {
  getCreateClaimCodeRoute,
  getCreateMementoAirdropRoute,
  getCreatePollRoute,
  getEditMerchDropRoute,
  getEditClaimCodeRoute,
  getEditMementoAirdropRoute,
  getEditPollRoute,
  getCreateMerchDropRoute,
  isMagnetInPublishedState,
  getCreateShareRequestRoute,
  getEditShareRequestRoute,
} from "utils/helpers";
import { get, post } from "utils/request";
import { ACTIVATIONS_ROUTE, TOAST_CONFIG } from "../../../../constants";
import ActivationComponent from "./ActivationComponent";

export default function Activation() {
  const [isCreateActivationModalVisible, setIsCreateActivationModalVisible] = useState(false);
  const {
    magnetDetailsState,
    magnetId,
    loading,
    error,
    magnetMementos,
    isMagnetMementosLoading,
    isRefreshingMagnetMementos,
    triggerRefetchMagnetMementos,
    magnetMementosFetchingError,
  } = useDataProviderContext();
  const router = useRouter();

  const brandId = magnetDetailsState?.brand_id;

  // Get magnet activations.

  // Get available activations for magnet.
  const {
    error: magnetActivationsError,
    data: availableActivationsForMagnet,
    isLoading: magnetActivationLoading,
    refetch: triggerRefetch,
  } = useQuery({
    queryKey: ["availableActivationsForMagnet", brandId, isCreateActivationModalVisible],
    queryFn: () =>
      // TODO: Need to change this to get activations for magnet.
      isCreateActivationModalVisible && brandId
        ? get(getActivationsForBrand(brandId), {
            processError: (errorMessage) => {
              throw Error(errorMessage);
            },
          })
        : null,
  });

  const handleOnClickActivateActivation = (selectedActivation: string) => {
    switch (selectedActivation) {
      case "mem_drop":
        router.go(getCreateMementoAirdropRoute(brandId as string, magnetId));
        break;
      case "poll":
        router.go(getCreatePollRoute(brandId as string, magnetId));
        break;
      case "merch_drop":
        router.go(getCreateMerchDropRoute(brandId as string, magnetId));
        break;
      case "claim_code":
        router.go(getCreateClaimCodeRoute({ brandId: brandId as string, magnetId }));
        break;
      case "social_share":
        router.go(getCreateShareRequestRoute({ brandId: brandId as string, magnetId }));
        break;
      default:
        workInProgressAlert();
    }
  };

  const handleOnClickManage = (mementoId: string, mementoActivationKey: string) => {
    switch (mementoActivationKey) {
      case "mem_drop":
        router.go(getEditMementoAirdropRoute(brandId as string, magnetId, mementoId));
        break;
      case "poll":
        router.go(getEditPollRoute(brandId as string, magnetId, mementoId));
        break;
      case "merch_drop":
        router.go(getEditMerchDropRoute(brandId as string, magnetId, mementoId));
        break;
      case "claim_code":
        router.go(getEditClaimCodeRoute({ brandId: brandId as string, magnetId, claimId: mementoId }));
        break;
      case "social_share":
        router.go(getEditShareRequestRoute({ brandId: brandId as string, magnetId, shareRequestId: mementoId }));
        break;
      default:
        router.go(getEditMementoAirdropRoute(brandId as string, magnetId, mementoId));
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>Oops, something went wrong. Please try again later.</div>;
  }

  if (magnetActivationLoading) {
    return <p>Loading Acitvations...</p>;
  }
  if (magnetActivationsError) {
    return <p>Couldnt fetch Magnet activations</p>;
  }

  if (isMagnetMementosLoading) {
    return <p>Loading Mementos....</p>;
  }

  if (magnetMementosFetchingError) {
    return <p>Loading Mementos Error....</p>;
  }

  const handlePurchaseActivation = (activationId: string) => {
    post(
      `${ACTIVATIONS_ROUTE}brand/${brandId}/map/${activationId}`,
      {},
      {
        processData: () => triggerRefetch(),
        processError: () => toast.error("Failed to activation activation for brand.", TOAST_CONFIG),
      },
    );
  };

  return (
    <ActivationComponent
      isMagnetPublished={isMagnetInPublishedState(magnetDetailsState?.status as MagnetStates)}
      mementosForMagnet={magnetMementos}
      availableActivations={(availableActivationsForMagnet || []) as Activation[]}
      handleOnClickActivateActivation={handleOnClickActivateActivation}
      isCreateActivationModalVisible={isCreateActivationModalVisible}
      setIsCreateActivationModalVisible={setIsCreateActivationModalVisible}
      handleOnClickManage={handleOnClickManage}
      handlePurchaseActivation={handlePurchaseActivation}
      handleRefetchActivations={triggerRefetch}
      triggerRefetchMagnetMementos={triggerRefetchMagnetMementos}
      isRefreshingMementoForMagnet={isRefreshingMagnetMementos}
    />
  );
}
